/**
 * PublicHomePage - Routes to correct page based on tenant context
 *
 * - Main domain (campanhaflow.com.br) -> LandingPage
 * - Tenant subdomain (lula.campanhaflow.com.br) -> SantinhoPage or Login redirect
 */

import { Navigate } from 'react-router-dom';
import { useTenant } from '@/contexts';
import { LandingPage } from '@/pages/landing/LandingPage';
import { SantinhoPage } from './SantinhoPage';

export function PublicHomePage() {
  const { isLandingPage, isTenantPage, hasPublicPage, isLoading } = useTenant();

  // Show loading while determining tenant
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  // Main domain -> Landing page
  if (isLandingPage) {
    return <LandingPage />;
  }

  // Tenant subdomain with public page enabled -> Santinho
  if (isTenantPage && hasPublicPage) {
    return <SantinhoPage />;
  }

  // Tenant subdomain without public page -> Login
  if (isTenantPage && !hasPublicPage) {
    return <Navigate to="/login" replace />;
  }

  // Fallback to landing
  return <LandingPage />;
}
